(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var ArrowRight=function ArrowRight(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M5 12h14M12 5l7 7-7 7"}))};var _default=ArrowRight;exports.Z=_default;

/***/ }),

/***/ 6664:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var ArrowUp=function ArrowUp(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M12 19V5M5 12l7-7 7 7"}))};var _default=ArrowUp;exports.Z=_default;

/***/ }),

/***/ 1582:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var Chrome=function Chrome(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("circle",{cx:"12",cy:"12",r:"10"}),/*#__PURE__*/_react["default"].createElement("circle",{cx:"12",cy:"12",r:"4"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M21.17 8H12M3.95 6.06L8.54 14M10.88 21.94L15.46 14"}))};var _default=Chrome;exports.Z=_default;

/***/ }),

/***/ 8345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var Cloud=function Cloud(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"}))};var _default=Cloud;exports.Z=_default;

/***/ }),

/***/ 264:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var CornerLeftDown=function CornerLeftDown(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M14 15l-5 5-5-5"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M20 4h-7a4 4 0 00-4 4v12"}))};var _default=CornerLeftDown;exports.Z=_default;

/***/ }),

/***/ 7988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var CreditCard=function CreditCard(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("rect",{width:"22",height:"16",x:"1",y:"4",rx:"2",ry:"2"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M1 10h22"}))};var _default=CreditCard;exports.Z=_default;

/***/ }),

/***/ 3723:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var Figma=function Figma(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M5 5.5A3.5 3.5 0 018.5 2H12v7H8.5A3.5 3.5 0 015 5.5zM12 2h3.5a3.5 3.5 0 110 7H12V2z"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M12 12.5a3.5 3.5 0 117 0 3.5 3.5 0 11-7 0zM5 19.5A3.5 3.5 0 018.5 16H12v3.5a3.5 3.5 0 11-7 0zM5 12.5A3.5 3.5 0 018.5 9H12v7H8.5A3.5 3.5 0 015 12.5z"}))};var _default=Figma;exports.Z=_default;

/***/ }),

/***/ 8930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
var _interopRequireDefault=__webpack_require__(5165);__webpack_unused_export__ = ({value:true});exports.Z=void 0;var _extends2=_interopRequireDefault(__webpack_require__(5632));var _objectWithoutProperties2=_interopRequireDefault(__webpack_require__(3469));var _react=_interopRequireDefault(__webpack_require__(2983));var Repeat=function Repeat(_ref){var _ref$color=_ref.color,color=_ref$color===void 0?"currentColor":_ref$color,_ref$size=_ref.size,size=_ref$size===void 0?24:_ref$size,props=(0,_objectWithoutProperties2["default"])(_ref,["color","size"]);return/*#__PURE__*/_react["default"].createElement("svg",(0,_extends2["default"])({fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1.5",shapeRendering:"geometricPrecision",viewBox:"0 0 24 24"},props,{height:size,width:size,style:{color:color}}),/*#__PURE__*/_react["default"].createElement("path",{d:"M17 1l4 4-4 4"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4"}),/*#__PURE__*/_react["default"].createElement("path",{d:"M21 13v2a4 4 0 01-4 4H3"}))};var _default=Repeat;exports.Z=_default;

/***/ }),

/***/ 6102:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9923);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; },
  "strings": function() { return /* binding */ pages_strings; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next-superjson-plugin@0.4.9_n4425kxx5r4jmllhb73qnfryoi/node_modules/next-superjson-plugin/tools.js
var tools = __webpack_require__(5630);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(9293);
// EXTERNAL MODULE: ../../packages/ui/src/components/heading/heading.tsx
var heading = __webpack_require__(7648);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/figma.js
var figma = __webpack_require__(3723);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/lock.js
var lock = __webpack_require__(8172);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/code.js
var code = __webpack_require__(3217);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(8527);
// EXTERNAL MODULE: ../../packages/ui/src/components/text/text.tsx
var text_text = __webpack_require__(9103);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/features/features.tsx





const contents = [
    {
        heading: "Easy customization",
        content: "You can customize widget styles to match your design system easily. ✨",
        icon: figma/* default */.Z
    },
    {
        heading: "Privacy at next level",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "You only need minimal info to get started, you can sign-in as an anonymous user or sign-in with email/magic link or social login providers. We never track you or sell your data. Learn more about"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                    className: "ml-1",
                    href: "/docs/features/privacy-friendly",
                    children: "privacy."
                })
            ]
        }),
        icon: lock/* default */.Z
    },
    {
        heading: "Open source",
        content: "Our source code is available and accessible on GitHub. You can read it, run it and inspect it to verify that our actions match with our promises.",
        icon: code/* default */.Z
    }
];
function Features() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "grid gap-8 lg:grid-cols-2 lg:gap-10",
        children: contents.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                    ...item
                })
            }, item.heading))
    });
}
function Feature(props) {
    const Icon = props.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-row space-x-4 sm:flex-col sm:space-x-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 inline-block h-fit w-fit rounded-full bg-primary-300 p-3 text-primary-1000",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    size: 26
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                        as: "h4",
                        className: "mb-3 font-semibold",
                        children: props.heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                        variant: "secondary",
                        className: "max-w-sm",
                        children: props.content
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(4517);
;// CONCATENATED MODULE: ../../packages/ui/src/components/icons/icon-arrow.tsx



function IconArrow(props) {
    var _props_size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : 100,
        viewBox: "0 0 176 112",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0,clsx_m/* default */.Z)(props.className, "rotate-180"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 109.032C12.9269 90.8896 27.5775 58.7965 53.0802 59.3761C72.6481 59.8208 78.7948 82.5425 89.8976 94.8142C120.301 128.418 149.852 41.639 159.501 24.1502C161.982 19.6522 168.018 -2.15518 169.262 7.17381C170.384 15.592 176.062 43.477 169.58 21.6037C167.726 15.3443 171.52 7.77959 165.336 3.14195C162.855 1.28128 140.05 18.2758 138.598 21.1793",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round"
        })
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/blocks/comment-widget-preview/comment-widget-preview.tsx + 3 modules
var comment_widget_preview = __webpack_require__(5267);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-widget-preview/home-comment-widget-preview.tsx




function HomeCommentWidgetPreview(param) {
    let { buildDate  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex translate-y-6 flex-col items-center text-gray-1100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-2 translate-x-10 text-2xl tracking-wider",
                        children: "Try it out!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrow, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full rounded-lg border border-gray-300 bg-gray-0 p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_widget_preview/* CommentWidgetPreview */.g, {
                    hideCommentTimeline: true,
                    rtePlaceholder: "Comment widget (Markdown supported)",
                    buildDate: buildDate
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/components/button/button.tsx
var button_button = __webpack_require__(7559);
// EXTERNAL MODULE: ../../packages/ui/src/components/card/card.tsx
var card = __webpack_require__(46);
// EXTERNAL MODULE: ../../packages/ui/src/components/divider/divider.tsx
var divider = __webpack_require__(3922);
// EXTERNAL MODULE: ../../packages/ui/src/components/list/list.tsx
var list = __webpack_require__(9648);
;// CONCATENATED MODULE: ../../packages/ui/src/components/section-header/section-header.tsx




/**
 * Landing page section header
 */ function SectionHeader(param) {
    let { title , description , label  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                color: "primary",
                className: "mb-3 text-center font-semibold",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                as: "h2",
                className: "mb-6 text-center text-5xl font-semibold",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                variant: "secondary",
                className: "mb-24 text-center",
                children: description
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/pricing/pricing.tsx










const COMMON_BENEFITS = [
    "Privacy-first, No Ads",
    "Rich text formatting",
    "Markdown shortcuts",
    "Third party sign in",
    "Advanced analytics",
    "Widget customization"
];
function Pricing(param) {
    let { id  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: "flex flex-col items-center px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                label: "Pricing",
                title: "Simple, transparent pricing",
                description: "Simple, transparent pricing that grows with you. Try a free plan, and upgrade at anytime."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col items-center space-y-4 md:flex-row md:items-start md:space-x-6 md:space-y-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard, {
                        plan: "Hobby",
                        price: "0",
                        callToAction: {
                            label: "Try It Free"
                        },
                        benefits: [
                            "1 Website",
                            ...COMMON_BENEFITS
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingCard, {
                        plan: "Pro",
                        price: "0",
                        benefits: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-gray-1200",
                                        children: "10"
                                    }),
                                    " Websites"
                                ]
                            }, "website"),
                            ...COMMON_BENEFITS,
                            "Comment with image",
                            "No branding"
                        ],
                        callToAction: {
                            label: "Get started",
                            buttonProps: {
                                color: "primary"
                            }
                        },
                        priceDescription: "Free for now"
                    })
                ]
            })
        ]
    });
}
function PricingCard(param) {
    let { plan , price , benefits , callToAction , priceDescription  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* Card */.Z, {
        className: "p-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                as: "h5",
                className: "mb-4 font-medium",
                children: plan
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                className: "mb-8",
                variant: "secondary",
                children: "All the basics for starting a new community"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_text/* Text */.x, {
                className: "mb-2 text-3xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "font-bold",
                        children: [
                            "$",
                            price
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                        as: "span",
                        variant: "secondary",
                        size: "base",
                        children: "/mo"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_text/* Text */.x, {
                className: "mb-8",
                variant: "secondary",
                children: [
                    priceDescription,
                    "​"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                variant: "plain",
                href: "/auth/sign-in",
                tabIndex: -1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    ...callToAction.buttonProps,
                    variant: "solid",
                    className: "mb-8 w-full",
                    children: callToAction.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {
                className: "-mx-6 mb-8 max-w-none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                bold: true,
                className: "mb-3",
                variant: "secondary",
                children: "WHAT'S INCLUDED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
                className: "space-y-2",
                children: benefits === null || benefits === void 0 ? void 0 : benefits.map((benefit, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List.Item */.a.Item, {
                        children: benefit
                    }, index))
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/utils/src/constants.ts
var constants = __webpack_require__(529);
;// CONCATENATED MODULE: ../../packages/ui/src/components/icons/feature-icon.tsx



/**
 * Feature icon accepts a single icon as a child, and overlap it with existing icons
 * @param props
 * @returns
 */ function FeatureIcon(props) {
    // Force the icon size
    const children = react.Children.map(props.children, (child)=>{
        return /*#__PURE__*/ react.cloneElement(child, {
            size: 24
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("relative w-[66px]", props.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "66",
                height: "66",
                viewBox: "0 0 66 66",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5 33C5 17.536 17.536 5 33 5V5C48.464 5 61 17.536 61 33V33C61 48.464 48.464 61 33 61V61C17.536 61 5 48.464 5 33V33Z",
                        fill: "currentColor",
                        className: "text-primary-400"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M33 56C20.2975 56 10 45.7025 10 33H0C0 51.2254 14.7746 66 33 66V56ZM56 33C56 45.7025 45.7025 56 33 56V66C51.2254 66 66 51.2254 66 33H56ZM33 10C45.7025 10 56 20.2975 56 33H66C66 14.7746 51.2254 0 33 0V10ZM33 0C14.7746 0 0 14.7746 0 33H10C10 20.2975 20.2975 10 33 10V0Z",
                        fill: "currentColor",
                        className: "text-primary-300"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-primary-900",
                children: children
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/faqs/faq.tsx



function FAQ(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col items-center px-4 sm:px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureIcon, {
                    className: "mb-5",
                    children: props.children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                    as: "h4",
                    className: "mb-2 max-w-xs font-semibold",
                    children: props.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                    variant: "secondary",
                    className: "max-w-sm",
                    children: props.description
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/heart.js
var heart = __webpack_require__(9991);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/repeat.js
var repeat = __webpack_require__(8930);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/cornerLeftDown.js
var cornerLeftDown = __webpack_require__(264);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/chrome.js
var chrome = __webpack_require__(1582);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/creditCard.js
var creditCard = __webpack_require__(7988);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/cloud.js
var cloud = __webpack_require__(8345);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/faqs/faq-data.tsx


const FAQ_LIST = [
    {
        title: "Is there a free plan available?",
        description: "Yes, we have a free plan for you. You can sign up for a free account and start using our service.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(heart/* default */.Z, {})
    },
    {
        title: "Can I change my plan later?",
        description: "Of course. Our pricing scales with your company. Chat to our friendly team to find a solution that works for you.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(repeat/* default */.Z, {})
    },
    {
        title: "What's your refund policy?",
        description: "We understand that things change. You can cancel your plan at any time and we'll refund you the difference already paid.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(cornerLeftDown/* default */.Z, {})
    },
    {
        title: "What browsers do you support?",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Chirpy is designed to work in the modern, recent releases of all major browsers, including Chrome, Firefox, Safari, and Edge.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "We don't support Internet Explorer."
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chrome/* default */.Z, {})
    },
    {
        title: "What payment methods do you support?",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Our payment is provided by",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                    href: "https://www.paddle.com/",
                    children: "Paddle"
                }),
                ". We accept all major credit, debit cards, PayPal, Google Pay, and Apple Pay.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                    href: "https://www.paddle.com/help/start/intro-to-paddle/which-payment-methods-do-you-support",
                    children: "More details"
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(creditCard/* default */.Z, {})
    },
    {
        title: "Can Chirpy be self-hosted?",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                "Yes, it is. It's exactly the same product as our Cloud solution, but you have to install, host and manage your own infrastructure while the Cloud version we manage everything for your ease and convenience. ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                    href: "https://chirpy.dev/docs/self-hosted",
                    children: "More details"
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(cloud/* default */.Z, {})
    }
];

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/faqs/faqs.tsx






function FAQs(param) {
    let { id  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex w-full flex-col items-center",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                label: "FAQs",
                title: "Ask us anything",
                description: "Need something cleared up? Here are our most frequently asked questions."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "mt-10 grid gap-8 lg:grid-cols-2 lg:gap-10 2xl:grid-cols-3",
                children: [
                    FAQ_LIST.map((param)=>/*#__PURE__*/ {
                        let { title , description , icon  } = param;
                        return (0,jsx_runtime.jsx)(FAQ, {
                            title: title,
                            description: description,
                            children: icon
                        }, title);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-full mt-8 flex flex-col rounded-lg bg-gray-0 px-5 py-8 lg:flex-row lg:items-start lg:justify-between lg:p-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "sm:0 mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                                        as: "h5",
                                        className: "mb-2 font-semibold",
                                        children: "Still have questions?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                                        variant: "secondary",
                                        className: "max-w-xs md:max-w-full",
                                        children: "Can't find the answer you're looking for? Please chat to our friendly team."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                variant: "plain",
                                href: constants/* FEEDBACK_LINK */.o9,
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                    variant: "solid",
                                    color: "primary",
                                    children: "Get in touch"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/arrowRight.js
var arrowRight = __webpack_require__(8220);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/home.tsx




function HomePage(param) {
    let { buildDate  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_layout/* default */.Z, {
        enableBgGradient: true,
        title: "",
        hideFullBleed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "flex min-h-full flex-col items-center space-y-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: "mt-1 w-full max-w-2xl text-center text-4xl font-black leading-snug text-gray-1200",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-block bg-gradient-to-r from-primary-900 to-plum-900 bg-clip-text text-transparent",
                                    children: strings.heroTitlePoint
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: strings.heroTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                            className: "text-center",
                            variant: "secondary",
                            children: strings.heroDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-center space-x-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                    variant: "plain",
                                    href: "/auth/sign-in",
                                    tabIndex: -1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_button/* Button */.z, {
                                        variant: "solid",
                                        color: "primary",
                                        className: "group space-x-1 hover:shadow-xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: strings.callToAction.main
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowRight/* default */.Z, {
                                                size: "20px",
                                                className: "inline-block transition group-hover:translate-x-1"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                    variant: "plain",
                                    href: "/docs",
                                    tabIndex: -1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        children: strings.callToAction.secondary
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[min(75ch,calc(100%-32px))]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCommentWidgetPreview, {
                        buildDate: buildDate
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pricing, {
                    id: "pricing"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs, {
                    id: "faqs"
                })
            ]
        })
    });
}
const strings = {
    heroTitlePoint: "Open source & privacy friendly",
    heroTitle: "Disqus alternate",
    heroDescription: "Build a better community by integrating a modern comment system.",
    callToAction: {
        main: "Get Early Access",
        secondary: "Learn More"
    }
};

;// CONCATENATED MODULE: ./src/pages/index.tsx

var __N_SSG = true;
const pages_strings = {
    heroTitlePoint: "Open source & privacy friendly",
    heroTitle: "Disqus alternate",
    heroDescription: "Build a better community by integrating a modern comment system.",
    callToAction: {
        main: "Get Early Access",
        secondary: "Learn More"
    }
};

/* harmony default export */ var pages = ((0,tools.withSuperJSONPage)(HomePage));


/***/ }),

/***/ 2223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ CommentForest; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(4517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.18_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(2468);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/components/button/base-button.tsx
var base_button = __webpack_require__(9051);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/arrowUp.js
var arrowUp = __webpack_require__(6664);
// EXTERNAL MODULE: ../../packages/ui/src/components/heading/heading.tsx
var heading = __webpack_require__(7648);
// EXTERNAL MODULE: ../../packages/ui/src/contexts/comment-context/comment-context-provider.tsx + 3 modules
var comment_context_provider = __webpack_require__(5589);
;// CONCATENATED MODULE: ../../packages/ui/src/utilities/get-comment-count.ts
function getCommentCount(comments) {
    let counter = 0;
    for (const comment of comments){
        if (comment.replies) {
            counter += getCommentCount(comment.replies) + 1;
        } else if (!comment.deletedAt) {
            counter++;
        }
    }
    return counter;
}

// EXTERNAL MODULE: ../../packages/ui/src/blocks/comment-branch/comment-branch.tsx
var comment_branch = __webpack_require__(2705);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/comment-card/comment-card.tsx + 4 modules
var comment_card = __webpack_require__(1701);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-tree/comment-tree.tsx




/**
 * Render a comment with it's replies, like a tree.
 */ function CommentTree(param) {
    let { comment , depth  } = param;
    var _comment_replies;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(comment_branch/* CommentBranch */.H, {
        transition: {
            duration: 0.2
        },
        initial: {
            opacity: 0,
            y: 50,
            scale: 0.3
        },
        animate: {
            opacity: 1,
            y: 0,
            scale: 1
        },
        hiddenBranch: depth === 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_card/* CommentCard */.p, {
                commentId: comment.id,
                author: comment.user,
                content: comment.content,
                likes: comment.likes,
                depth: depth,
                createdAt: comment.createdAt,
                deletedAt: comment.deletedAt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "w-[calc(100%-2rem)] sm:w-[calc(100%-4rem)]",
                    children: (_comment_replies = comment.replies) === null || _comment_replies === void 0 ? void 0 : _comment_replies.map((reply)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CommentTree, {
                            comment: reply,
                            depth: depth + 1
                        }, reply.id))
                })
            })
        ]
    }, comment.id);
}


// EXTERNAL MODULE: ../../packages/ui/src/blocks/notification-hub/notification-hub.tsx + 2 modules
var notification_hub = __webpack_require__(9217);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/rich-text-editor/rich-text-editor.tsx + 8 modules
var rich_text_editor = __webpack_require__(2333);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/user-menu/user-menu.tsx
var user_menu = __webpack_require__(4068);
// EXTERNAL MODULE: ../../packages/ui/src/hooks/use-storage.ts
var use_storage = __webpack_require__(3546);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-forest/use-comment-order-by.ts

function useCommentOrderBy() {
    return (0,use_storage/* useLocalStorage */._)("desc", "comment-order-by");
}

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-forest/comment-forest.tsx













function CommentForest(param) {
    let { comments , rtePlaceholder  } = param;
    const { createAComment  } = (0,comment_context_provider/* useCommentContext */.E)();
    const commentCount = getCommentCount(comments);
    const [orderBy, setOrderBy] = useCommentOrderBy();
    const orderedComments = sortComments(comments, orderBy);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                        as: "h3",
                        className: "!text-2xl",
                        children: formatTitle(commentCount)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_hub/* NotificationHub */.u, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(user_menu/* UserMenu */.I, {
                                variant: "Widget"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "space-y-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text_editor/* RichTextEditor */.L, {
                            placeholder: rtePlaceholder || "What are your thoughts? (Markdown supported)",
                            onSubmit: createAComment
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row items-center justify-end space-x-1",
                        children: orderedComments.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shadow-inner rounded-lg border border-gray-700 bg-gray-500 ring-1 ring-gray-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                                "aria-label": "Reorder comments",
                                className: "m-1 rounded border border-gray-700 bg-gray-0 p-0.5 text-gray-1200 shadow hover:bg-gray-200",
                                onClick: ()=>setOrderBy((prev)=>prev === "asc" ? "desc" : "asc"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowUp/* default */.Z, {
                                    className: (0,clsx_m/* default */.Z)("transition", orderBy === "asc" && "rotate-180")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "space-y-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                            children: orderedComments === null || orderedComments === void 0 ? void 0 : orderedComments.map((comment)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CommentTree, {
                                    depth: 1,
                                    comment: comment
                                }, comment.id))
                        })
                    })
                ]
            })
        ]
    });
}
function sortComments(comments, orderBy) {
    if (!orderBy) {
        return comments;
    }
    const orderedComments = [
        ...comments
    ].sort((a, b)=>orderBy === "asc" ? dateToNumber(a.createdAt) - dateToNumber(b.createdAt) : dateToNumber(b.createdAt) - dateToNumber(a.createdAt));
    for (const comment of orderedComments){
        var _comment_replies;
        if (((_comment_replies = comment.replies) === null || _comment_replies === void 0 ? void 0 : _comment_replies.length) > 1) {
            // @ts-ignore
            comment.replies = sortComments(comment.replies, orderBy);
        }
    }
    return orderedComments;
}
function formatTitle(count) {
    if (count === 0) {
        return "Comment";
    } else if (count === 1) {
        return "1 comment";
    }
    return "".concat(count, " comments");
}
function dateToNumber(date) {
    return date.getTime();
}


/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ CommentWidgetPreview; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/components/toast/use-toast.ts
var use_toast = __webpack_require__(9948);
// EXTERNAL MODULE: ../../packages/ui/src/contexts/comment-context/comment-context.ts
var comment_context = __webpack_require__(9531);
// EXTERNAL MODULE: ../../packages/ui/src/contexts/current-user-context/use-current-user.ts
var use_current_user = __webpack_require__(3814);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/comment-forest/comment-forest.tsx + 3 modules
var comment_forest = __webpack_require__(2223);
// EXTERNAL MODULE: ../../packages/utils/src/function.ts
var src_function = __webpack_require__(9828);
// EXTERNAL MODULE: ../../packages/ui/src/contexts/current-user-context/current-user-context.ts
var current_user_context = __webpack_require__(6889);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-widget-preview/predefined-current-user.tsx




/**
 * Provide existing or predefined current user context
 * @param props
 * @returns
 */ function PredefinedCurrentUser(props) {
    const originalContext = react.useContext(current_user_context/* CurrentUserContext */.E);
    const [currentUser, setCurrentUser] = react.useState(()=>({
            loading: false,
            isSignIn: true,
            data: {
                editableProjectIds: [],
                id: "ffad5f9c-0c28-4c9b-a652-b21a2a42949b",
                username: "michael",
                email: "michael@chirpy.dev",
                name: "Michael",
                image: "/images/avatars/male-2.jpeg"
            },
            refetchUser: src_function/* asyncNoop */.C
        }));
    react.useEffect(()=>{
        if (originalContext.data.id) {
            setCurrentUser(originalContext);
        }
    }, [
        originalContext
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(current_user_context/* CurrentUserContext.Provider */.E.Provider, {
        value: currentUser,
        children: props.children
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/contexts/notification-context/notification-provider.tsx + 3 modules
var notification_provider = __webpack_require__(4346);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-widget-preview/predefined-notification.tsx




/**
 * Provide predefined notification context
 * @param props
 * @returns
 */ function PredefinedNotification(props) {
    const notificationContext = react.useMemo(()=>({
            registerNotification: src_function/* asyncNoop */.C,
            didRegister: false,
            didDeny: false,
            setDidRegister: src_function/* noop */.Z,
            supportNotification: false
        }), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_provider/* NotificationContext.Provider */.uj.Provider, {
        value: notificationContext,
        children: props.children
    });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/dayjs@1.11.6/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4123);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-widget-preview/preview-data.ts

const PAGE_ID = "b5a16120-593c-492f-ad94-e14d247485f3";
const PROJECT_ID = "3c5d2d41-e2df-4b31-98f8-6e471acab461";
const UserJane = {
    __typename: "User",
    id: "634da1be-cc04-4719-908e-c642de76e292",
    name: "Jane",
    image: "/images/avatars/female-1.jpeg"
};
const getPreviewComments = (date)=>{
    const dateTime = dayjs_min_default()(date);
    return [
        {
            __typename: "Comment",
            id: "4f5f8d1f-ed42-44ff-a4cd-f7b51af55e1f",
            content: {
                type: "doc",
                content: [
                    {
                        type: "paragraph",
                        content: [
                            {
                                type: "text",
                                text: "Your article is 100% gorgeous \uD83D\uDE0D"
                            }
                        ]
                    }
                ]
            },
            createdAt: dateTime.subtract(50, "hours").toDate(),
            parentId: null,
            pageId: PAGE_ID,
            user: UserJane,
            likes: [],
            replies: [
                {
                    id: "87110a09-9a4b-4f41-8784-6f8512449ddf",
                    content: {
                        type: "doc",
                        content: [
                            {
                                type: "paragraph",
                                content: [
                                    {
                                        type: "text",
                                        text: "Can't agree more!"
                                    }
                                ]
                            }
                        ]
                    },
                    createdAt: dateTime.subtract(49, "hours").toDate(),
                    parentId: "4f5f8d1f-ed42-44ff-a4cd-f7b51af55e1f",
                    pageId: PAGE_ID,
                    user: {
                        id: "634da1be-cc04-4719-908e-c642de76e292",
                        name: "Dianne",
                        image: "/images/avatars/female-2.jpeg"
                    },
                    likes: [
                        {
                            id: "dd4812a5-031f-4534-8713-be586927081f",
                            userId: UserJane.id
                        }
                    ],
                    replies: []
                }
            ]
        },
        {
            id: "7a024861-7dce-4513-9f8a-c9e91d975da4",
            content: {
                type: "doc",
                content: [
                    {
                        type: "paragraph",
                        content: [
                            {
                                type: "text",
                                text: "Interesting, thanks for sharing."
                            }
                        ]
                    }
                ]
            },
            createdAt: dateTime.subtract(25, "hours").toDate(),
            parentId: null,
            pageId: PAGE_ID,
            user: {
                id: "634da1be-cc04-4719-908e-c642de76e292",
                name: "William",
                image: "/images/avatars/male-1.jpeg"
            },
            likes: [],
            replies: []
        }
    ];
};

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/comment-widget-preview/comment-widget-preview.tsx









/**
 * Comment widget preview, used by theme editor and home page
 */ function CommentWidgetPreview(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PredefinedCurrentUser, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PredefinedNotification, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentWidgetPreviewInternal, {
                ...props
            })
        })
    });
}
function CommentWidgetPreviewInternal(props) {
    const { data  } = (0,use_current_user/* useCurrentUser */.x)();
    const [previewComments, setPreviewComments] = react.useState(()=>getPreviewComments(props.buildDate));
    const createAComment = react.useCallback(async (reply, commentId)=>{
        const newComment = {
            id: "".concat(String(Math.random()).slice(2)),
            content: reply,
            parentId: commentId || null,
            pageId: PAGE_ID,
            createdAt: new Date(),
            user: {
                id: data.id || "",
                name: data.name || "",
                image: data.image || ""
            },
            replies: [],
            likes: []
        };
        if (!commentId) {
            // This is a root comment
            setPreviewComments((prevData)=>[
                    ...prevData,
                    newComment
                ]);
            return;
        }
        setPreviewComments((prevData)=>{
            const comment = findCommentById(prevData, commentId);
            if (comment) {
                comment.replies.push(newComment);
            }
            return [
                ...prevData
            ];
        });
    }, [
        data
    ]);
    const deleteAComment = react.useCallback(async (commentId)=>{
        setPreviewComments((prevData)=>{
            return deleteACommentById(prevData, commentId);
        });
        return;
    }, []);
    const toggleALikeAction = react.useCallback(async (isLiked, likeId, commentId)=>{
        setPreviewComments((prevData)=>{
            const comment = findCommentById(prevData, commentId);
            if (comment) {
                comment.likes = comment.likes.filter((like)=>like.id !== likeId);
                if (!isLiked) {
                    comment.likes.push({
                        id: likeId,
                        userId: data.id || ""
                    });
                }
            }
            return [
                ...prevData
            ];
        });
    }, [
        data.id
    ]);
    const { showToast  } = (0,use_toast/* useToast */.p)();
    const onClickCommentTimeline = react.useCallback(()=>{
        showToast({
            title: "You clicked a comment's timeline",
            type: "info"
        });
    }, [
        showToast
    ]);
    const commentContext = react.useMemo(()=>({
            pageId: PAGE_ID,
            projectId: PROJECT_ID,
            createAComment,
            deleteAComment,
            toggleALikeAction,
            onClickCommentTimeline,
            ...props.hideCommentTimeline && {
                hideCommentTimeline: true
            }
        }), [
        createAComment,
        deleteAComment,
        toggleALikeAction,
        onClickCommentTimeline,
        props.hideCommentTimeline
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_context/* CommentContext.Provider */.Y.Provider, {
        value: commentContext,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_forest/* CommentForest */.N, {
            comments: previewComments,
            rtePlaceholder: props.rtePlaceholder || "Preview"
        })
    });
}
function findCommentById(comments, id) {
    return findCommentByIdInternal(comments, id)[0];
}
function findCommentByIdInternal(comments, id) {
    let result = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    for (const comment of comments){
        if (comment.id === id) {
            result.push(comment);
            break;
        } else {
            findCommentByIdInternal(comment.replies, id, result);
        }
    }
    return result;
}
function deleteACommentById(comments, id) {
    const newComments = [];
    for (const comment of comments){
        if (comment.id === id) {
            comment.deletedAt = new Date();
        }
        comment.replies = deleteACommentById(comment.replies, id);
        newComments.push(comment);
    }
    return newComments;
}


/***/ }),

/***/ 9648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ List; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2983);



const variantTags = {
    ordered: "ol",
    unordered: "ul"
};
function List(param) {
    let { className , variant ="unordered" , ...restProps } = param;
    const Tag = variantTags[variant];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex list-none flex-col py-2", className)
    });
}
List.Item = ListItem;
function ListItem(param) {
    let { className , children , styles ={} , hideMarker , ...liProps } = param;
    const ChildrenContainer = typeof children === "string" ? "span" : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        ...liProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row items-center space-x-2 text-gray-1100", className),
        children: [
            !hideMarker && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("h-2 w-2 rounded-full bg-current", styles.marker)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ChildrenContainer, {
                children: children
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [755,393,98,146,570,293,109,774,888,179], function() { return __webpack_exec__(6102); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);